module.exports = __webpack_public_path__ + "static/leaf left-d4947138eb24eeb067842bd389c11ce4.png";